(function ($) {
    var halo = {
        initPoliciesSlider: function () {
            var policyBlock = $('[data-top-message-slide]');

            policyBlock.each(function () {
                var self = $(this),
                    rows = self.data('row');

                if (self.not('.slick-initialized')) {
                    self.slick({
                        slidesToShow: rows,
                        slidesToScroll: 1,
                        vertical: true,
                        autoplay: true,
                        dots: false,
                        speed: 800,
                        get nextArrow() {
                            return this.nextArrow = '';
                        },
                        get prevArrow() {
                            return this.prevArrow = '';
                        },
                    });
                }
            });
        }
    }
    halo.initPoliciesSlider();
})(jQuery);
